import React from 'react';
import { CHAIN_STAGES, shouldRecommendAdvancedFiltration, cascadeEnable, cascadeDisable } from '../../calculations/filtrationCalculations.js';
import RecommendationBanner from './RecommendationBanner.js';

const TAMIS_MODULE = { id: 'tamis', label: 'Tamis grossier', desc: 'Filtration des feuilles/débris en amont de la cuve (descente de gouttière)', cost: { low: 80, high: 250 } };

/**
 * Section Filtration : le tamis grossier reste une ligne fixe (descente de cuve), séparée
 * de la chaîne de traitement en série (micro-filtration → charbon actif → UV). Cliquer sur
 * un étage active automatiquement tous les étages qui le précèdent ; le désactiver désactive
 * automatiquement les étages en aval — la sélection reste toujours un préfixe contigu.
 */
const FiltrationSection = ({ filtration, setFiltration, usages }) => {
  const recommended = shouldRecommendAdvancedFiltration(usages);
  const tamisOn = filtration.moduleIds.includes('tamis');

  const toggleTamis = () => {
    const next = tamisOn ? filtration.moduleIds.filter(m => m !== 'tamis') : [...filtration.moduleIds, 'tamis'];
    setFiltration({ moduleIds: next });
  };

  const toggleStage = (id) => {
    const active = filtration.moduleIds.includes(id);
    setFiltration({ moduleIds: active ? cascadeDisable(id, filtration.moduleIds) : cascadeEnable(id, filtration.moduleIds) });
  };

  return (
    <div>
      <label className="rw-checkbox-opt" style={{ marginBottom: 16 }}>
        <input type="checkbox" checked={tamisOn} onChange={toggleTamis} />
        <div>
          <div className="rw-budget-card-label">{TAMIS_MODULE.label} <span className="rw-chain-fixed-badge">en descente de cuve</span></div>
          <div className="rw-budget-card-desc">{TAMIS_MODULE.desc}</div>
          <div className="rw-budget-card-price">{TAMIS_MODULE.cost.low} – {TAMIS_MODULE.cost.high} €</div>
        </div>
      </label>

      {recommended && (
        <RecommendationBanner>
          Un usage sensible (lave-linge) est actif à l'étape 1 — la chaîne complète (micro-filtration + charbon +
          désinfection UV) est recommandée pour la qualité d'eau exigée par cet usage.
        </RecommendationBanner>
      )}

      <div className="rw-sub-label">Chaîne de traitement en série</div>
      <p className="apv2-sim-hint">
        Chaque étage se branche à la suite du précédent — cliquez directement sur un étage pour l'ajouter avec
        tous ceux qui le précèdent dans la chaîne.
      </p>

      <div className="rw-chain">
        {CHAIN_STAGES.map((stage, i) => {
          const active = filtration.moduleIds.includes(stage.id);

          return (
            <React.Fragment key={stage.id}>
              {i > 0 && <div className={`rw-chain-connector ${active ? 'rw-chain-connector--active' : ''}`} />}
              <div
                className={`rw-chain-stage ${active ? 'rw-chain-stage--active' : ''}`}
                onClick={() => toggleStage(stage.id)}
              >
                <div className="rw-chain-stage-index">{i + 1}</div>
                <div className="rw-chain-stage-label">{stage.label}</div>
                <div className="rw-chain-stage-desc">{stage.description}</div>
                <div className="rw-chain-stage-price">{stage.cost.low} – {stage.cost.high} €</div>
              </div>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default FiltrationSection;
